<template>
<transition name="fade">
  <form
  v-if="$route.path === '/login' || !logged"
  class="login_container"
  method="post"
  ref="login_form"
  :action="app_path + 'main.php?action=login'"
  @submit.prevent="login"
  style="z-index: 1000;"
  >
    <div class="login_box">
      <div class="text-input">
        <input 
        v-model="username"
        type="text" name="username" placeholder="Nom d'utilisateur">
      </div>
      <div class="text-input">
        <input 
        v-model="password"
        type="password" name="password" placeholder="Mot de passe">
      </div>
      <div class="submit-input">
        <input
        type="submit"
        value="Connexion"
        >
      </div>
    </div>
    <notifications group="auth" :max="3" position="top center"/>
  </form>
  <v-layout
  ref="layout"
  style="display: none;"
  :class="{
    logged: logged
  }"
  v-else-if="metaLoaded.orgs && metaLoaded.groups &&  metaLoaded.attributes &&  metaLoaded.services">
    <nav slot="header" class="navbar primary">
      <!-- <div class="navbar-title">
        ANNUAIRE FNE PACA
      </div> -->
      <div class="navbar tabs">
        <a v-no-select
        class="is-narrow"
        @click="toggleDrawer"
        style="min-width: 64px">
          <div class="rows items-center">
            <i class="menu"></i>
            <!-- <div class="tab-title">Déconnexion</div> -->
          </div>
        </a>
        <router-link to="/gestion/contact"
        exact
        v-no-select>
          <div class="rows items-center">
            <i class="users"></i>
            <div class="tab-title is-hidden-mobile ">Contacts</div>
          </div>
        </router-link>
        <router-link to="/gestion/organisation"
        exact
        v-no-select>
          <div class="rows items-center">
            <i class="institution"></i>
            <div class="tab-title is-hidden-mobile ">Organisations</div>
          </div>
        </router-link>
        <router-link to="/gestion/contact_externe"
        exact
        v-no-select>
          <div class="rows items-center">
            <i class="users"></i>
            <div class="tab-title is-hidden-mobile ">Contacts externes</div>
          </div>
        </router-link>
        <router-link to="/gestion/organisation_externe"
        exact
        v-no-select>
          <div class="rows items-center">
            <i class="institution"></i>
            <div class="tab-title is-hidden-mobile ">Organisations externes</div>
          </div>
        </router-link>
        <router-link to="/mailing/messages"
        v-no-select>
          <div class="rows items-center">
            <i class="mail"></i>
            <div class="tab-title is-hidden-mobile ">Mailing</div>
          </div>
        </router-link>
        <router-link to="/config/comptes"
        v-no-select>
          <div class="rows items-center">
            <i class="build"></i>
            <div class="tab-title is-hidden-mobile">Configuration</div>
          </div>
        </router-link>
        <a v-no-select
        class="is-narrow"
        style="min-width: 64px"
        @click="logout">
          <div class="rows items-center">
            <i class="sign-out"></i>
            <!-- <div class="tab-title">Déconnexion</div> -->
          </div>
        </a>
      </div>
    </nav>

    <v-drawer ref="leftDrawer">
      <!-- <transition name="vfade"> -->
        <router-view 
        name="menu"
        class="transition"
        ></router-view>
      <!-- </transition> -->
    </v-drawer>

    <div 
    id="layout-view"
    class="layout-view">
      <transition name="slide">
        <router-view 
        id="transition"
        class="transition"
        :key="$route.fullPath" 
        ></router-view>
      </transition>
    </div>

    <div slot="footer">
      <router-view class="view" name="footer"></router-view>
    </div>
  </v-layout>
</transition>
</template>

<script>
// import Vue from 'vue'
import Vuex from 'vuex'
import FastClick from 'fastclick'
/*
 * Root component
 */

// global.rights = null
// global.univers = null
// global.expiration = null
global.login_data = {}
global.univers = 0

export default {
  data () {
    return {
      username: '',
      password: '',
      // logged: true,
      app_path: global.app_path
    }
  },

  computed: {
    ...Vuex.mapGetters({
      metaLoaded: 'metaLoaded',
      logged: 'logged',
    })
    // logged: function () {
    //   return localStorage.getItem('id_token') !== null
    // }

  },

  methods: {
    login: function (e) {
      var vm = this
      this.$http.post(
        global.app_path + 'main.php?action=login', {
          username: this.username,
          password: this.password
        }, {
          emulateJSON: true
        }
      )
      .then((response) => {
        // var token = response.headers.get('Authorization')
        // localStorage.setItem('id_token', token)
        // console.log(response.body)
        vm.$store.commit('SetLogged', true)
        // console.log('SetLogged', response.body)

        // global.rights = null
        // global.univers = null
        // global.expiration = null
        // global.token = response.body.token
        global.login_data = response.body
        global.univers = parseInt(response.body.univers)
        // global.login_data = {
        //   rights: response.body.rights,
        //   univers: response.body.univers,
        //   expiration: response.body.expiration
        // }

        // console.log(global.login_data)

        vm.username = ''
        vm.password = ''
        // global.univers
        vm.$store.dispatch('get_orgs')
        vm.$store.dispatch('get_groups')
        vm.$store.dispatch('get_attributes')
        vm.$store.dispatch('get_services')
        vm.$nextTick(function () {
          this.$router.push('/gestion/contact')
        })
      }, (response) => {
        console.log(response)
        
        this.$notify({
          group: 'auth',
          type: 'error',
          // type: 'warn',
          position: 'top center',
          duration: 10000,
          'animation-type': 'velocity',
          text: 'Echec de la connexion'
        })
      })
      // return false
    },
    logout: function () {
      localStorage.removeItem('id_token')
      localStorage.removeItem('id_token_expiration')
      this.$store.commit('SetLogged', false)
      this.$router.push('/login')
    },

    go: function (target) {
      this.$router.push(target)
    },

    onSwipe: function (e) {
      // alert(JSON.stringify(e))
      // console.log('back', e, this.page_back)

      // if (e.direction === 'right' &&
      // this.page_back !== null &&
      // e.distance.x > 100) {
      // this.go(this.page_back)

      // this.$router.replace(this.page_back)
      if (this.page_back) {
        this.$router.push(this.page_back)
      }

      // }

      // this.$router.push(target)
    },

    toggleDrawer: function () {
      this.$refs.leftDrawer.toggle()
    },

    manageCookie: function () {
      global.uid = 0
      var cookie_str = ''
      var value = document.cookie
      var tmp = value.match(/;? ?ntp_uid=([^;]+)/)
      if (tmp && tmp.length > 1) {
        global.uid = tmp[1]
      }

      global.set_uid = function (uid) {
        if (uid && uid !== '' && uid !== global.uid) {
          var expires = new Date(
            new Date().setFullYear(new Date().getFullYear() + 1)
          )

          document.cookie = 'ntp_uid=' + uid + '; ' +
          'expires=' + expires.toUTCString() + ';'
        }
      }
    }
  },

  // watch: {

  // },
  beforeDestroy: function () {
    this.$refs.layout.innerHTML = ''
  },

  mounted: function () {
    let vm = this
    FastClick.attach(document.body)

    let id_token = localStorage.getItem('id_token')

    if (!id_token) {

      this.$store.commit('SetLogged', false)
      if(this.$router.history.current.path != "/login"){
        this.$router.replace('/login')
      }
    }

    var html_splash = document.getElementById('html-splash')

    html_splash.style.opacity = 0
    setTimeout(function () {
      html_splash.style.display = 'none'
    }, 300)
    
    this.$store.dispatch('get_orgs')
    this.$store.dispatch('get_groups')

    this.$store.dispatch('get_attributes')
    this.$store.dispatch('get_services')
  }
}
</script>

<style>
.login_container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #67BE4B;
  background-color: #1976D2;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.login_box {
  background-color: #fff;
  display: inline-block;
  padding: 40px;
  min-width: 25%;
  max-width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25),
    0 10px 10px rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 768px) {
  .login_box {
    padding: 0px;
  }
}

.login_box > div {
  margin: 20px;
}

.login_box > div.text-input {
  background-color: #F2F2F2;
}

.login_box input {
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: 1.25rem;
  height: 4rem;
  line-height: 4rem;
  border-radius: 2px;
  color: #777;
  background-color: transparent;
  border: none;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  min-width: 0%;
  outline: none;
  padding: 0 1rem;
}

.login_box > .submit-input > input {
  color: #fff;
  background-color: #00B242;
  text-align: center;
}

.layout.logged {
  display: flex !important;
}

.layout-view {
  width: auto;
  flex: 1;
}

.notification-content {
  font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;
  font-size: 1.25rem;
}

.item-link-with-icon {
  display: flex;
  height: auto;
  line-height: 100%;
  min-height: 48px;
  margin-left: 10px;
}

.item-link-with-icon > i,
.item-link-with-icon > div{
  padding: 10px 5px;
}

.item-link-with-icon > div{
  flex: 1;
  line-height: 26px;
}

/*
.notifications{
  display:block;
  position:fixed;
  z-index:5000
}
.notification-wrapper{
  display:block;
  overflow:hidden;
  width:100%;
  margin:0;
  padding:0
}
.notification{
  display:block;
  box-sizing:border-box;
  background:#fff;
  text-align:left
}
.notification-title{
  font-weight:600
}
.vue-notification{
  font-size:12px;
  padding:10px;
  margin:0 5px 5px;
  color:#fff;
  background:#44a4fc;
  border-left:5px solid #187fe7
}
.vue-notification.warn{
  background:#ffb648;
  border-left-color:#f48a06
}
.vue-notification.error{
  background:#e54d42;
  border-left-color:#b82e24
}
.vue-notification.success{
  background:#68cd86;
  border-left-color:#42a85f
}
.vn-fade-enter-active,.vn-fade-leave-active,.vn-fade-move{
  transition:all .5s
}
.vn-fade-enter,.vn-fade-leave-to{
  opacity:0
}*/

</style>
